import type { SxProps, Theme } from "@mui/material/styles";

/**
 * The content column of every page, from the click dummy's `.pf-main`: one
 * 1040px column centred on the page, 24px gutters, and a 20px rhythm between
 * the hero, the search, the count and the list.
 */
export const pageColumn: SxProps<Theme> = {
  width: "100%",
  maxWidth: 1040,
  mx: "auto",
  px: { xs: 2, sm: 3 },
  pt: { xs: 2.5, sm: 3.5 },
  pb: 5,
  display: "grid",
  gap: 2.5,
  alignContent: "start",
};

export default pageColumn;
